import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPhoneTopPunchHoleCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconPhoneTopPunchHoleCenter"><Path d="M3.75 20.25V6.75C3.75 5.09315 5.09315 3.75 6.75 3.75H17.25C18.9069 3.75 20.25 5.09315 20.25 6.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><Circle cx="12" cy="6.5" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconPhoneTopPunchHoleCenter;
